import { Component, OnInit, signal, ViewChild } from '@angular/core';
import { TripDetail, TripDetailService } from 'src/app/api';
import { LocalAuthService } from 'src/app/auth/local-auth.service';
import { ConfigService } from 'src/app/config.service';
import { IconService } from 'src/app/ui/icon.service';
import { DateTime } from 'luxon';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { Column } from 'src/app/ui';

@Component({
  selector: 'app-teams-registered',
  templateUrl: './teams-registered.component.html',
  styleUrl: './teams-registered.component.scss',
  standalone: false
})
export class TeamsRegisteredComponent implements OnInit {

  constructor(
    public icons: IconService,
    private config: ConfigService,
    public auth: LocalAuthService,
    private tripDetailService: TripDetailService,
    private router: Router
  ) {}

  @ViewChild('dt2') dt2!: Table;

  tripDetail = signal<TripDetail[]>([]);
  startDate = signal<Date>(DateTime.now().minus({ days: 7 }).startOf("day").toJSDate());
  endDate = signal<Date>(DateTime.now().endOf("day").toJSDate());


  tableColumns = signal<Column<TripDetail>[]>([
    { field: 'groupName', header: 'Group Name', sortable: true, filterable: true, type: 'text' },
    { field: 'location', header: 'Destination', sortable: true, filterable: true, type: 'text' },
    { field: 'glName', header: 'Group Leader', sortable: true, filterable: true, type: 'text' },
    { field: 'id', header: 'Trip ID', sortable: true, filterable: true, type: 'tripIdWithLink', tripIdField: 'id', custIdField: 'custId' },
    { field: 'dateReserved', header: 'Date Registered', sortable: true, filterable: true, type: 'date' },
    { field: 'recruiterName', header: 'Recruiter', sortable: true, filterable: true, type: 'text' },
    { field: 'attendees', header: 'Actual', sortable: true, filterable: true, type: 'number' },
    { field: 'attendeesOriginal', header: 'Original', sortable: true, filterable: true, type: 'number' },

  ])


  filterTableGlobal(e: any) {
    this.dt2.filterGlobal(e.target.value, 'contains');
}

  ngOnInit(): void {
    this.getTrips();
  }

  getTrips() {
    const startDateToUse = this.startDate();
    const endDateToUse = this.endDate();

    this.tripDetailService.getRegisteredTeams(startDateToUse, endDateToUse).subscribe({
      next: (trips) => {
        this.tripDetail.set(trips); 
      },
      error: (err) => {
        console.error("Error fetching trips: ", err);
      }
    });
  }

  navigateToContactCard(custID: number, tripId: number) {
    this.router.navigate(['contact-card', custID],  {
      queryParams: { trip: tripId },
      fragment: 'payments'
    });
  }
}
